import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "billType",
    "billTypeOtherDesc",
    "childbirthNotice"
  ]

  connect() {
    this.refresh();
  }

  billTypeChanged() {
    this.refresh();
  }

  refresh() {
    if (this.billTypeTarget.value == 'Other') {
      this.billTypeOtherDescTarget.classList.remove('hidden');
    } else {
      this.billTypeOtherDescTarget.classList.add('hidden');
    }

    if (this.billTypeTarget.value == "Childbirth - mother's bill" || this.billTypeTarget.value == "Childbirth - newborn's bill") {
      this.childbirthNoticeTarget.classList.remove('hidden');
    } else {
      this.childbirthNoticeTarget.classList.add('hidden');
    }
  }
}